import Vue from 'vue';
import {ValidationObserver} from 'vee-validate';
import {ProviderInstance} from 'vee-validate/dist/types/types';

export const ValidationUtilsMixin = Vue.extend({
	components: {
		ValidationObserver
	},

	data: () => ({
		formValid: false
	}),

	methods: {
		getValidationObserver (): InstanceType<typeof ValidationObserver>
		{
			return this.$refs.observer as InstanceType<typeof ValidationObserver>;
		},

		validateForm (silent: boolean): Promise<boolean>
		{
			return new Promise<boolean>((resolve, reject) =>
			{
				this.$nextTick(() =>
				{
					const observer = this.getValidationObserver();
					if (!observer)
					{
						reject(new Error('Couldn\'t find a ValidationObserver with ref=\'observer\' on the page'));
					}
					else
					{
						observer.validateWithInfo({silent}).then((info) =>
						{
							this.formValid = info.isValid;
							resolve(info.isValid);
						});
					}
				});
			});
		},

		// Gets the validator named 'provider' contained within the parentRef
		getValidator (parentRef: string): ProviderInstance | null
		{
			const ref = this.$refs[parentRef] as Vue;
			if (ref)
			{
				return ref.$refs.provider as ProviderInstance;
			}
			return null;
		},

		// Syncs the value with the validator named 'provider' contained within the parentRef.
		// If shouldValidate is true, it will also call the validation function immedietly.
		syncValidator (parentRef: string, shouldValidate: boolean, val?: any)
		{
			const validator = this.getValidator(parentRef);
			if (validator)
			{
				validator.syncValue(val);
				if (shouldValidate)
				{
					validator.validate();
				}
			}
		}
	}
});
